/**
 * make changes if necessary to tdo name
 */
export const formatTDOName = (inputName: string): string => {
  let name = inputName;

  // trim leading spaces (causes problems when downloading)
  name = name.trimStart();

  // can add more rules later if necessary such as correcting file extension, removing/replacing problematic characters
  return name;
};

/**
 * Byte count as the UI shows file sizes — KB below a megabyte, then MB, then GB,
 * always two decimals. Matches the private copies in MediaDetailsPage/RedactedFiles
 * and DocumentEditorPage/RedactedFilePreview so an asset reads the same wherever
 * it is listed; those two should be folded into this one.
 */
export const formatFileSize = (bytes: number): string => {
  const KB = 1024;
  const MB = KB * 1024;
  const GB = MB * 1024;
  if (bytes >= GB) {
    return `${(bytes / GB).toFixed(2)} GB`;
  }
  if (bytes >= MB) {
    return `${(bytes / MB).toFixed(2)} MB`;
  }
  return `${(bytes / KB).toFixed(2)} KB`;
};

export const DISPLAY_FILE_NAME_MAX_LENGTH = 60;

export const truncateDisplayFileName = (
  name: string,
  maxLength = DISPLAY_FILE_NAME_MAX_LENGTH
) => {
  if (name.length <= maxLength) {
    return name;
  }

  const lastDot = name.lastIndexOf('.');
  const extension = lastDot > 0 ? name.slice(lastDot) : '';
  const baseMaxLength = maxLength - extension.length - 3;

  if (baseMaxLength <= 0) {
    return `${name.slice(0, maxLength - 3)}...`;
  }

  return `${name.slice(0, baseMaxLength)}...${extension}`;
};
